import { render, staticRenderFns } from "./SolAgoraFisico.vue?vue&type=template&id=f65509d0&"
import script from "./SolAgoraFisico.vue?vue&type=script&lang=js&"
export * from "./SolAgoraFisico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports